module.exports = __webpack_public_path__ + "img/gard_vertical_4.848d5114.png";